import styles from "../../../styles/Participant-Employment.module.css"
import { Calendar } from "primereact/calendar"
import { checkErrorValidation } from "./formikAux"
const CalendarField = ({
  label,
  value,
  setValue,
  valueName,
  error,
  required,
  size,
  showErrorMessage,
  subText,
  minValue,
  maxValue
}) => {
  return (
    <>
      <div className={styles.field} style={{ width: `${size ? size : "30"}%` }}>
        <label
          className={`${styles.label} ${required && styles.requiredField}`}
        >
          {label}
        </label>
        <Calendar
          dateFormat="dd/mm/yy"
          showIcon
          panelClassName="custom_calendar_panel"
          value={value}
          minDate={minValue ? minValue : undefined}
          maxDate={maxValue ? maxValue : undefined}
          yearRange={`1900:${new Date().getFullYear()}`}
          yearNavigator
          monthNavigator
          onChange={(e) => {
            valueName ? setValue(valueName, e.value) : setValue(e.value)
          }}
          className={`${styles.calendar} ${checkErrorValidation(error) ? styles.invalid : ""
            }`}
        />
        {subText && (
          <div>
            <span style={{ fontSize: "14px" }}>{subText}</span>
          </div>
        )}
        {showErrorMessage && <div>{checkErrorValidation(error) && error}</div>}
      </div>
    </>
  )
}
export default CalendarField
